/* Open every collapsed section before the page prints, and put it back afterwards. */
(() => {
  let opened = [];

  const openAll = () => {
    opened = Array.from(document.querySelectorAll('details:not([open])'));
    opened.forEach((d) => d.setAttribute('open', ''));
  };

  const restore = () => {
    opened.forEach((d) => d.removeAttribute('open'));
    opened = [];
  };

  window.addEventListener('beforeprint', openAll);
  window.addEventListener('afterprint', restore);

  // Safari fires neither event; it drives the same thing through a media query listener.
  const query = window.matchMedia('print');
  if (query.addEventListener) {
    query.addEventListener('change', (event) => (event.matches ? openAll() : restore()));
  }
})();
